/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState } from 'react';

import { FormHoc, Input, Select, SelectBase, TextArea } from '../../atoms/Form';
import { useDialog } from '../../atoms/Dialog';
import {
    CsLpUzel, csLpUzelCreate, CsLpUzelCreate, csLpUzelUpdate, CsLpUzelUpdate,
    CsLpUzelBaseValidation, CsLpUzelNovyPotomekValidation
} from '../../../api';
import useApi from '../../../hooks/useApi';
import SendingContainer from '../../hoc/SendingContainer';

type ModeType = 'new' | 'select' | 'update';

interface IFormUzelProps {
    selUzel?: number
    data?: any
    uzly: CsLpUzel[]
    reload: () => void
}

function FormUzel({ data, uzly, reload, selUzel }: IFormUzelProps) {
    const { call: newUzl, sending: sendingN, error: errorN } = useApi<void, CsLpUzelCreate>({});
    const { call: updUzl, sending: sendingU, error: errorU } = useApi<void, CsLpUzelUpdate>({});
    const { closeDialog } = useDialog();
    const [mode, setMode] = useState<ModeType | ''>(data ? 'update' : '');

    const onSubmit = useCallback(
        async (values: any) => {

            let response;
            if (mode === 'new')
                response = await newUzl(csLpUzelCreate(values));
            else if (mode === 'update')
                response = await updUzl(csLpUzelUpdate(data?.id || selUzel, values))
            else if (mode === 'select') {
                const uzel: any = uzly.find(item => (item.id === selUzel))
                uzel?.child?.push(Number(values.novyPotomekId));
                response = await updUzl(csLpUzelUpdate(data?.id || selUzel, uzel));
            }

            if (response !== false) {
                reload();
                closeDialog();
            }
        },
        [mode, newUzl, updUzl, data?.id, selUzel, uzly, reload, closeDialog]
    );

    return (
        <SendingContainer sending={sendingN || sendingU} error={errorN || errorU}>
            {
                selUzel && <>
                    <SelectBase
                        name='parentId'
                        label='Rodičovský uzel'
                        value={selUzel}
                        disabled>
                        {
                            uzly.map(item => (
                                <option key={item.id} value={item.id}>{item.id} - {item.shorttext}</option>
                            ))
                        }
                    </SelectBase>
                    <SelectBase
                        name='mode'
                        label='Způsob vzniku potomka'
                        value={mode}
                        onChange={e => setMode(e.target.value as ModeType)}>
                        <option value='' disabled>-</option>
                        <option value='new'>vytvoření nového uzlu</option>
                        <option value='select'>připojení existujícího uzlu</option>
                    </SelectBase>
                </>
            }

            {
                mode === 'select' &&
                <FormHoc
                    onSubmit={onSubmit}
                    defaultValues={{ ...data, parentId: selUzel }}
                    validationSchema={CsLpUzelNovyPotomekValidation}
                >
                    {
                        ({ submitHandler }) => (
                            <form
                                onSubmit={submitHandler}
                                noValidate>
                                <Select
                                    name='novyPotomekId'
                                    label='Výběr uzlu'
                                    required>
                                    <option value='' disabled>-</option>
                                    {
                                        uzly.map(item => (
                                            <option key={item.id} value={item.id}>{item.id} - {item.shorttext}</option>
                                        ))
                                    }
                                </Select>
                                <button
                                    id='form-uzel-submit'
                                    className='display-none' />
                            </form>
                        )
                    }
                </FormHoc>
            }

            {
                (mode === 'new' || mode === 'update') &&
                <FormHoc
                    onSubmit={onSubmit}
                    defaultValues={selUzel ? { ...data, parentId: selUzel } : data}
                    validationSchema={CsLpUzelBaseValidation}
                >
                    {
                        ({ submitHandler }) => (
                            <form
                                onSubmit={submitHandler}
                                noValidate>

                                <Input
                                    name='shorttext'
                                    label='Název' />
                                <TextArea
                                    name='longtext'
                                    label='Obsah' />
                                <button
                                    id='form-uzel-submit'
                                    className='display-none' />
                            </form>
                        )
                    }
                </FormHoc>
            }
        </SendingContainer>
    );
}

export default FormUzel;